import { render, staticRenderFns } from "./NolaNovel.vue?vue&type=template&id=b24c1666&scoped=true"
import script from "./NolaNovel.vue?vue&type=script&lang=ts"
export * from "./NolaNovel.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovel.vue?vue&type=style&index=0&id=b24c1666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c1666",
  null
  
)

export default component.exports